import * as dffHelpers from "./dff-helpers";
import * as defaultHelpers from "./default";
import * as awfHelpers from "./awf-helpers";
import * as afrHelper from "./afr-helpers";
import * as zidrHelpers from "./zidr-helpers";

const getChartData = (state, role, platform) => {
  const functionsMap = {
    dff: dffHelpers.getChartData,
    awf: awfHelpers.getChartData,
    afr: afrHelper.getChartData,
    zidr: zidrHelpers.getChartData,
  };
  return functionsMap[platform]
    ? functionsMap[platform](state, role)
    : defaultHelpers.getChartData(state, role);
};

const getStatusCounts = (state, role, platform) => {
  const functionsMap = {
    dff: dffHelpers.getStatusCounts,
    awf: awfHelpers.getStatusCounts,
    afr: afrHelper.getStatusCounts,
    zidr: zidrHelpers.getStatusCounts,
  };
  return functionsMap[platform]
    ? functionsMap[platform](state, role)
    : defaultHelpers.getStatusCounts(state, role);
};

const bottomLinks = (platform) => {
  const linksMap = {
    dff: dffHelpers.bottomLinks,
    awf: awfHelpers.bottomLinks,
    afr: afrHelper.bottomLinks,
    zidr: { ...defaultHelpers.bottomLinks, ...zidrHelpers.bottomLinks },
  };
  return linksMap[platform] || defaultHelpers.bottomLinks;
};

export { getChartData, getStatusCounts, bottomLinks };
